import React from 'react';

import { IWfaLabel, IWfaSessionDetails } from 'src/apps/wfa/services/WfaDashboardServiceTypes';
import { TagsBlock } from 'src/common/components/tags-block/TagsBlock';

import { getTagsFromSessionDetails } from './helpers';

interface ISessionInfoBlockProps {
	sessionDetails: IWfaSessionDetails;
	isThreeColumns?: boolean;
	overridenLabels?: IWfaLabel[];
}

export const SessionInfoBlock: React.FC<ISessionInfoBlockProps> = ({
	sessionDetails,
	isThreeColumns,
	overridenLabels
}) => {
	return (
		<TagsBlock
			isThreeColumns={isThreeColumns}
			tagGroups={getTagsFromSessionDetails(sessionDetails, overridenLabels)}
		/>
	);
};
